import React from 'react';
import HackSubmissionForm from "../components/HackSubmissionForm";
import { checkConnection } from '../lib/wordpress';

const Submit = () => {
  const [isConnected, setIsConnected] = React.useState<boolean | null>(null);

  React.useEffect(() => {
    const verifyConnection = async () => {
      const connected = await checkConnection();
      setIsConnected(connected);
    };
    verifyConnection();
  }, []);

  if (isConnected === null) {
    return (
      <div className="min-h-screen flex flex-col">
        <main className="flex-grow container mx-auto px-4 py-12">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto"></div>
          </div>
        </main>
      </div>
    );
  }

  if (!isConnected) {
    return (
      <div className="min-h-screen flex flex-col">
        <main className="flex-grow container mx-auto px-4 py-12">
          <div className="max-w-2xl mx-auto p-6 bg-red-50 border border-red-200 rounded-lg">
            <h2 className="text-xl font-bold text-red-800 mb-4">Connection Required</h2>
            <p className="text-red-700 mb-4">
              The submit page requires a connection to continue. Please ensure:
            </p>
            <ul className="list-disc pl-5 text-red-700 space-y-2">
              <li>The server is running on port 10212</li>
              <li>Required plugins are installed and activated</li>
              <li>CORS is properly configured</li>
            </ul>
            <div className="mt-6">
              <a
                href="/cms-setup"
                className="text-blue-600 hover:underline"
              >
                Go to CMS Setup
              </a>
            </div>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-grow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <h1 className="text-3xl font-bold mb-8">Submit a Disability Hack</h1>
          <HackSubmissionForm />
        </div>
      </main>
      {/* Footer is included in App.tsx layout */}
    </div>
  );
};

export default Submit;
